import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import NenhumRegistro from '../../NenhumRegistro';
import {
  FiEdit2, FiBriefcase, FiMail, FiPhone, FiMapPin,
  FiTag, FiHome, FiDollarSign, FiPercent, FiUser, FiKey,
} from 'react-icons/fi';
import { Link } from 'react-router-dom';
import Apis from '../../Apis';
import axios from 'axios';

const ALTERA_PRECO_MAP = { '0': 'Não Permitir', '1': 'Permitir Alterar', '2': 'Somente Para Mais' };
const SIM_NAO = { '0': 'Sim', '1': 'Não' };

function InfoField({ icon, label, value }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: 16,
      padding: 20, borderRadius: 10,
      background: '#f8fafc', border: '1px solid #f1f5f9',
      transition: 'all 0.15s',
    }}
      onMouseEnter={e => { e.currentTarget.style.background = '#f0f4ff'; e.currentTarget.style.borderColor = '#bbd8ea'; }}
      onMouseLeave={e => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#f1f5f9'; }}
    >
      <div style={{
        width: 42, height: 42, borderRadius: 8, flexShrink: 0,
        background: 'linear-gradient(135deg, rgba(82,148,181,0.14), rgba(82,148,181,0.1))',
        color: '#5294b5',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        border: '1px solid rgba(82,148,181,0.17)',
      }}>
        {icon}
      </div>
      <div>
        <p style={{ margin: '0 0 4px', fontSize: 10.5, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', lineHeight: 1 }}>
          {label}
        </p>
        <p style={{ margin: 0, fontSize: 14.5, color: '#0f172a', fontWeight: 600 }}>
          {value || '—'}
        </p>
      </div>
    </div>
  );
}

function Section({ title, icon, children, cols = 2 }) {
  return (
    <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', height: '100%' }}>
      <div style={{ padding: '20px 28px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1.5px solid #f1f5f9' }}>
        <div style={{ width: 30, height: 30, borderRadius: 6, background: 'rgba(82,148,181,0.1)', color: '#5294b5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {icon}
        </div>
        <span style={{ fontSize: 12.5, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
          {title}
        </span>
      </div>
      <div style={{ padding: 24, display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: 16 }}>
        {children}
      </div>
    </div>
  );
}

export default function ListarEmpresa() {
  const [empresa, setEmpresa] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.post(
      Apis.urlListarOneEmpresas,
      { id: localStorage.getItem('id') },
      { headers: { 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') } }
    )
      .then((res) => {
        const regs = res.data.registros || [];
        
        if (regs.length > 0) {
          setEmpresa(regs[0]);
          localStorage.setItem('nome', regs[0].nome);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401 || err?.response?.status === 400) {
          localStorage.clear();
          window.location.href = '/login';
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;
  if (!empresa) return <NenhumRegistro nome="empresa" pagina="/semButton" />;

  const enderecoCompleto = [empresa.logradouro, empresa.numero].filter(Boolean).join(', ') || '—';

  return (
    <div style={{ padding: '24px 28px' }}>

      {/* ── Hero banner ── */}
      <div style={{ borderRadius: 16, overflow: 'hidden', marginBottom: 24, boxShadow: '0 4px 24px rgba(67,56,202,0.13)' }}>
        {/* Top gradient strip */}
        <div style={{
          background: 'linear-gradient(135deg, #0a1520 0%, #1e3a4c 45%, #162e3c 100%)',
          padding: '40px 48px', position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: -60, right: -60, width: 220, height: 220, borderRadius: '50%', background: 'rgba(82,148,181,0.14)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', bottom: -80, right: 120, width: 180, height: 180, borderRadius: '50%', background: 'rgba(82,148,181,0.1)', pointerEvents: 'none' }} />

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
              {/* Avatar */}
              <div style={{
                width: 80, height: 80, borderRadius: 12, flexShrink: 0,
                background: 'linear-gradient(135deg, rgba(82,148,181,0.36), rgba(82,148,181,0.22))',
                border: '2px solid rgba(165,180,252,0.3)',
                color: '#bbd8ea',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 8px 24px rgba(0,0,0,0.25)',
              }}>
                <FiBriefcase size={36} />
              </div>

              <div>
                <h2 style={{ margin: '0 0 4px', fontWeight: 800, color: '#fff', fontSize: '1.4rem', textTransform: 'uppercase', letterSpacing: '0.03em', lineHeight: 1.2 }}>
                  {empresa.nome}
                </h2>
                {empresa.fantasia && (
                  <p style={{ margin: '0 0 12px', color: '#90c3d8', fontSize: 14, fontWeight: 400 }}>
                    {empresa.fantasia}
                  </p>
                )}
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 16px', borderRadius: 40, background: 'rgba(74,222,128,0.12)', border: '1px solid rgba(74,222,128,0.25)' }}>
                  <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80', boxShadow: '0 0 6px #4ade80' }} />
                  <span style={{ fontSize: 12, color: '#bbf7d0', fontWeight: 600 }}>Empresa ativa</span>
                </div>
              </div>
            </div>

            <Link to="/alterar-empresas" title="Editar" style={{ textDecoration: 'none' }}>
              <button style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 24px', borderRadius: 10,
                border: '1px solid rgba(165,180,252,0.4)',
                background: 'rgba(82,148,181,0.12)',
                color: '#bbd8ea', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                fontFamily: 'inherit', transition: 'background 0.15s',
              }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(82,148,181,0.27)'; e.currentTarget.style.borderColor = '#90c3d8'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(82,148,181,0.12)'; e.currentTarget.style.borderColor = 'rgba(165,180,252,0.4)'; }}
              >
                <FiEdit2 size={14} /> Editar Empresa
              </button>
            </Link>
          </div>
        </div>

        {/* Quick stats bar */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', background: '#fff' }}>
          {[
            { icon: <FiTag size={13} />,    label: 'CNPJ',     value: empresa.cnpj },
            { icon: <FiMail size={13} />,   label: 'E-mail',   value: empresa.email },
            { icon: <FiPhone size={13} />,  label: 'Telefone', value: empresa.telefone },
            { icon: <FiMapPin size={13} />, label: 'Cidade',   value: empresa.cidade ? `${empresa.cidade}${empresa.uf ? ' / ' + empresa.uf : ''}` : '—' },
          ].map(({ icon, label, value }, idx) => (
            <div key={label} style={{
              padding: '24px 32px',
              borderRight: idx < 3 ? '1px solid #e2e8f0' : 'none',
              borderTop: '1px solid #e2e8f0',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', color: '#5294b5', marginBottom: 4, gap: 4 }}>
                {icon}
                <span style={{ fontSize: 10, color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em' }}>{label}</span>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: '#0f172a', fontWeight: 700 }}>{value || '—'}</p>
            </div>
          ))}
        </div>
      </div>

      {/* ── Info sections ── */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>

        <Section title="Identificação" icon={<FiTag size={14} />} cols={2}>
          <InfoField icon={<FiTag size={17} />}  label="CNPJ"     value={empresa.cnpj} />
          <InfoField icon={<FiTag size={17} />}  label="IE / RG"  value={empresa.ie} />
          <InfoField icon={<FiMail size={17} />}  label="E-mail"   value={empresa.email} />
          <InfoField icon={<FiPhone size={17} />}  label="Telefone" value={empresa.telefone} />
        </Section>

        <Section title="Endereço" icon={<FiMapPin size={14} />} cols={2}>
          <InfoField icon={<FiMail size={17} />}   label="CEP"          value={empresa.cep} />
          <InfoField icon={<FiMapPin size={17} />} label="Cidade / UF"  value={empresa.cidade ? `${empresa.cidade}${empresa.uf ? ' / ' + empresa.uf : ''}` : '—'} />
          <InfoField icon={<FiHome size={17} />}   label="Logradouro"   value={enderecoCompleto} />
          <InfoField icon={<FiHome size={17} />}   label="Complemento"  value={empresa.complemento} />
        </Section>

        <Section title="Configurações" icon={<FiDollarSign size={14} />} cols={2}>
          <InfoField icon={<FiDollarSign size={17} />} label="Financeiro na Venda"      value={SIM_NAO[String(empresa.financeiro_venda)]} />
          <InfoField icon={<FiPercent size={17} />}    label="Permitir Desconto"        value={SIM_NAO[String(empresa.permite_desconto)]} />
          <InfoField icon={<FiUser size={17} />}       label="Venda Cliente Autorizado" value={SIM_NAO[String(empresa.venda_cliente_autorizado)]} />
          <InfoField icon={<FiDollarSign size={17} />} label="Alterar Preço"            value={ALTERA_PRECO_MAP[String(empresa.altera_preco_pedido)]} />
        </Section>

        {empresa.token && (
          <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 12, overflow: 'hidden' }}>
            <div style={{ padding: '20px 28px', display: 'flex', alignItems: 'center', gap: 12, borderBottom: '1.5px solid #f1f5f9' }}>
              <div style={{ width: 30, height: 30, borderRadius: 6, background: 'rgba(82,148,181,0.1)', color: '#5294b5', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <FiKey size={14} />
              </div>
              <span style={{ fontSize: 12.5, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                Token de Integração
              </span>
            </div>
            <div style={{ padding: 24 }}>
              <div style={{ padding: 20, borderRadius: 8, background: '#0f172a', border: '1px solid #1e293b' }}>
                <p style={{ margin: 0, fontSize: 13, color: '#90c3d8', fontFamily: 'monospace', letterSpacing: '0.06em', wordBreak: 'break-all', lineHeight: 1.7 }}>
                  {empresa.token}
                </p>
              </div>
              <p style={{ marginTop: 12, marginBottom: 0, fontSize: 12, color: '#94a3b8' }}>
                Use este token para integrar aplicações externas com a plataforma.
              </p>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
